module.exports = {
  SAVE_WEARABLES: 'SAVE_WEARABLES',
  APPEND_WEARABLES: 'APPEND_WEARABLES',
  SAVE_WEARABLES_PAGINATION: 'SAVE_WEARABLES_PAGINATION',
  SET_SELECTED_WEARABLE: 'SET_SELECTED_WEARABLE',
  UPDATE_WEARABLE: 'UPDATE_WEARABLE',
  REMOVE_WEARABLE: 'REMOVE_WEARABLE',
  RESET_WEARABLES_DATA: 'RESET_WEARABLES_DATA',
  SET_WEARABLES_FILTER: 'SET_WEARABLES_FILTER',
  RESET_WEARABLES_FILTERS: 'RESET_WEARABLES_FILTERS',
  SAVE_WEARABLE_HISTORY: 'SAVE_WEARABLE_HISTORY',
  APPEND_WEARABLE_HISTORY: 'APPEND_WEARABLE_HISTORY',
  SAVE_WEARABLE_HISTORY_PAGINATION: 'SAVE_WEARABLE_HISTORY_PAGINATION',
  SET_WEARABLE_HISTORY_FILTER: 'SET_WEARABLE_HISTORY_FILTER',
  RESET_WEARABLE_HISTORY_FILTER: 'RESET_WEARABLE_HISTORY_FILTER',
  RESET_WEARABLE_HISTORY_DATA: 'RESET_WEARABLE_HISTORY_DATA',
  SET_WEARABLE_ORDER: 'SET_WEARABLE_ORDER',
  SET_WEARABLE_OPERATIONAL_MODE: 'SET_WEARABLE_OPERATIONAL_MODE',
  SAVE_WEARABLE_ALARMS: 'SAVE_WEARABLE_ALARMS',
  APPEND_WEARABLE_ALARMS: 'APPEND_WEARABLE_ALARMS',
  SAVE_WEARABLE_ALARMS_PAGINATION: 'SAVE_WEARABLE_ALARMS_PAGINATION',
  SET_WEARABLE_ALARMS_FILTER: 'SET_WEARABLE_ALARMS_FILTER',
  RESET_WEARABLE_ALARMS_FILTER: 'RESET_WEARABLE_ALARMS_FILTER',
  RESET_WEARABLE_ALARMS_DATA: 'RESET_WEARABLE_ALARMS_DATA',
  UPDATE_WEARABLE_ALARM_IN_STATE: 'UPDATE_WEARABLE_ALARM_IN_STATE',
  SAVE_ACTIVE_ALARMS: 'SAVE_ACTIVE_ALARMS',
};
